import React, { useState } from "react";
import {
  Modal,
  Button,
  Alert,
  Table,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { useImpersonate, useUsers } from "services/account";

interface ImpersonateModalProps {
  show: boolean;
  onHide: () => void;
}

const ImpersonateModal: React.FC<ImpersonateModalProps> = ({
  show,
  onHide,
}) => {
  const [error, setError] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { mutateAsync: impersonate } = useImpersonate();
  const { data, isLoading } = useUsers();

  // Função para iniciar a personificação
  const handleImpersonate = async (email: string) => {
    try {
      await impersonate(email);
      onHide(); // Fechar o modal após personificação bem-sucedida
    } catch (err) {
      console.error("Erro ao personificar usuário:", err);
      setError(
        "Não foi possível personificar o usuário selecionado. Verifique suas permissões ou tente novamente."
      );
    }
  };

  // Filtrar usuários com base no termo de busca
  const usuariosFiltrados = data?.filter(
    (usuario: any) =>
      usuario.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      usuario.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Personificar Usuário</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p>
          Selecione um usuário para personificar. Isso permitirá que você
          utilize o sistema como se fosse o usuário selecionado.
        </p>
        <p>
          <strong>Importante:</strong> Todas as ações realizadas durante a
          personificação serão registradas.
        </p>

        <InputGroup className="mb-3">
          <InputGroup.Text>
            <i className="fas fa-search"></i>
          </InputGroup.Text>
          <FormControl
            placeholder="Buscar por nome ou email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>

        {isLoading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Funções</th>
                  <th className="text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {usuariosFiltrados?.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="text-center">
                      {searchTerm
                        ? "Nenhum usuário encontrado com esse termo de busca."
                        : "Nenhum usuário disponível."}
                    </td>
                  </tr>
                ) : (
                  usuariosFiltrados?.map((usuario: any) => (
                    <tr key={usuario.email}>
                      <td>{usuario.nome}</td>
                      <td>{usuario.email}</td>
                      <td>
                        {usuario.roles.map((role: any, index: number) => (
                          <span key={index} className="badge bg-primary me-1">
                            {role}
                          </span>
                        ))}
                      </td>
                      <td className="text-center">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => handleImpersonate(usuario.email)}
                        >
                          Personificar
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImpersonateModal;
